import * as React from 'react';
import { CnButton } from '@alife/cn-ui';
import './index.scss';
export function TestButton({ className = '', content = '', onClick = () => {
    // eslint-disable-next-line no-console
    console.log('default clicked');
}, }) {
    return (<div className={`my-component-wrap ${className}`}>
      <CnButton className="my-blue-btn" onClick={onClick}>
        test btn
      </CnButton>
      test btn
      <div>{content}</div>
    </div>);
}
TestButton.displayName = 'TestButton';
